module.exports = __webpack_public_path__ + "img/operatorGuide6.787a28db.png";